import React from 'react';
import { Star, Quote } from 'lucide-react';

const SocialProof = () => {
  const testimonials = [
    {
      id: 1,
      text: 'Ótimo atendimento ao cliente, ótimo preço e super atenciosos',
      author: 'Cliente Google',
      rating: 5,
    },
    {
      id: 2,
      text: 'Adquiri o box do banheiro e o fechamento da varanda. Qualidade impecável!',
      author: 'Cliente Google',
      rating: 5,
    },
    {
      id: 3,
      text: 'O atendimento desde a venda até a montagem e revisão são muito bons',
      author: 'Cliente Google',
      rating: 5,
    },
  ];

  return (
    <section className="section-padding bg-[var(--bg-secondary)]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className="w-8 h-8 text-[var(--accent-gold)] fill-current"
              />
            ))}
          </div>
          <h2 className="heading-1 mb-4">Avaliado com 4.6 estrelas no Google</h2>
          <p className="body-regular text-[var(--text-secondary)]">
            Mais de 40 avaliações de clientes satisfeitos
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-white p-8 hover-lift fade-in"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[var(--accent-gold)] mb-4" />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-[var(--accent-gold)] fill-current"
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="body-regular text-[var(--text-primary)] mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <p className="body-small text-[var(--text-secondary)] font-medium">
                {testimonial.author}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://www.google.com/maps/search/forti+vidros+sorocaba"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[var(--text-secondary)] hover:text-[var(--accent-gold)] transition-colors"
          >
            <span className="body-small">Ver todas as avaliações no Google</span>
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
